import { Skeleton } from 'antd';

export const SkeletonPage = () => <Skeleton active paragraph={{ rows: 8 }} />;
